module.exports = __webpack_public_path__ + "img/loading.7d7fac33.png";